$(function() {
	// Verifica hash ao iniciar
	URI.init();

	var swiper = new Swiper('.banner', {
		pagination: '.swiper-pagination',
		paginationClickable: true,
		effect: 'fade',
		autoplay: 6500
	});

	// Menu fixed scroll
	var menuTop = $('#menu-desktop').offset().top;
	var menuHeight = $('#menu-desktop').outerHeight();
	$(window).scroll(function() {
		var scrollTop = $(window).scrollTop();
		if (scrollTop > menuTop) {
			$('#menu-desktop').addClass('navbar-fixed-top');
			//$("body").css('margin-top', menuHeight);
			$('#footer-btn-back-top').show();
		} else {
			$('#menu-desktop').removeClass(' navbar-fixed-top');
			//$("body").css('margin-top', 0);
			$('#footer-btn-back-top').hide();
		}
	});

	$(document).on('click', '.pop-up', function(e) {
		$('.pop-up').fadeOut('fast');
	});

	$(document).on('click', '.p-u-container', function(e) {
		e.preventDefault();
		return false;
	});

	$(document).on('click', '.p-u-c-close', function(e) {
		$('.pop-up').fadeOut('fast');
	});

	$(document).on('click', '.p-u-c-link', function(e) {
		$('.pop-up').fadeOut('fast');
		var url = $(this).attr('ref');
		window.open(url, '_blank');
	});

	/*

    $(".submenu a").click(function(){
        $(this).parent('.submenu').hide();
    });

    $(".menu-item.sm").hover(function(){
        $(this).find('.submenu').show();
    },function(){
        $(this).find('.submenu').hide();
    });

    $("#scrool-top").click(function(){
        $('body, html').animate({scrollTop: 0}, 500);
    });

    $(".sh-menuitem").click(function(){
      URI.change();
    });

    $("#search-btn").click(function(){
        var search = $("#search").val();
        if(search.length > 2)
            window.location = '/#/search/'+encodeURIComponent(search);
    });

    $("#search-btn-mobile").click(function(){
        var search = $("#search-mobile").val();
        if(search.length > 2)
            window.location = '/#/search/'+encodeURIComponent(search);
    });

    $("#search").keyup(function(event){
        if(event.keyCode == 13){
            $("#search-btn").click();
        }
    });

    $(".home-tb-fa[title]").qtip({position:{my:'top,center', at:'bottom, center'}, style: {classes: 'qtip-light'}});

    $(".back_top").click(function(){
        $('body, html').animate({scrollTop: 0}, 900);
    });
*/

	$(document).off('click', '.menu-mobile');
	$(document).on('click', '.menu-mobile', function(e) {
		e.stopPropagation();
		$('.menu-mobile-container').addClass('open');
	});

	$(document).off('click', '.menu-mobile-container-click');
	$(document).on('click', '.menu-mobile-container-click', function(e) {
		e.stopPropagation();
		$('.menu-mobile-container').removeClass('open');
		(<any>$('.collapse')).collapse('hide');
	});

	$(document).on('click', function(e) {
		if ($(e.target).closest('.menu-mobile-container').length === 0) {
			$('.menu-mobile-container').removeClass('open');
			(<any>$('.collapse')).collapse('hide');
		}
	});
});
